import { LocaleDetails } from "../types/languages.type";

export const formatId = (id: string) => {
  // Remove the last 6 characters if the last 5 match the pattern xx-XX
  if (/^[a-z]{2}-[A-Z]{2}$/.test(id.slice(-5))) {
    id = id.replaceAll(/-[a-z]{2}-[A-Z]{2}/g, ""); // Remove last 6 characters
  }
  return id;
};

export const formatIdIntoTitle = ({
  id,
  locale,
}: {
  id: string;
  locale: LocaleDetails;
}) => {
  let title = id;

  title = title.replace(/-[a-z]{2}-[A-Z]{2}/g, "");
  
  // Remove streaming cache suffix like "-prod-0", "-prod-1" etc.
  title = title.replace(/-prod-\d+$/g, "");

  // Replace hyphens with spaces
  title = title.split("-").join(" ");

  // Capitalize based on locale.langCode
  if (locale.languageCode === "en") {
    // Capitalize the first letter of each word
    title = title.replace(/(^\w)|(\s\w)/g, (match: string) =>
      match.toUpperCase()
    );
  } else {
    // Capitalize only the first letter of the entire string
    title = title.replace(/^./, (match: string) => match.toUpperCase());
  }

  return title;
};
